// ActivityLogService.tsx
import { BaseService } from '../../core/BaseService';
import { PaginationParams, Wrapper } from '../../type';
import { GetActionsListResponse, GetActivityLogResponse, GetIntegrationLogsResponse } from './interface';

export class ActivityLogProfile extends BaseService {
  async getActivityLogs(params: PaginationParams) {
    return this.get<GetActivityLogResponse>(`${this.apiUrl}/api/requestlogs/paged`, params);
  }

  async getActionsList() {
    return this.get<GetActionsListResponse>(`${this.apiUrl}/api/requestlogs/actionslist`);
  }

  async getIntegrationLogs(params: PaginationParams) {
    return this.get<GetIntegrationLogsResponse>(`${this.apiUrl}/api/integration/logs/paged`, params);
  }

  async retryIntegrationLog(id: number) {
    return this.post<Wrapper, Record<string, never>>(`${this.apiUrl}/api/flex-price/send-event/${id}`, {});
  }

  async sendJobCardToIntegration(jobCardId: number) {
    return this.post<Wrapper, Record<string, never>>(`${this.apiUrl}/api/jobs/sendjobcard/${jobCardId}`, {});
  }

  async sendEstimateToIntegration(estimateId: number) {
    return this.post<Wrapper, Record<string, never>>(`${this.apiUrl}/api/jobs/sendestimate/${estimateId}`, {});
  }

  async sendWorkOrderToIntegration(workOrderId: number) {
    return this.post<Wrapper, Record<string, never>>(`${this.apiUrl}/api/jobs/sendworkorder/${workOrderId}`, {});
  }

  async sendInvoiceToIntegration(invoiceId: number) {
    return this.post<Wrapper, Record<string, never>>(`${this.apiUrl}/api/jobs/sendinvoice/${invoiceId}`, {});
  }
}
